// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e879070","952":"2c670455"}[chunkId] + ".chunk.js";
};